import {
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE,
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST,
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS,
    FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS,
    GET_LOCKERS_COUNT,
} from '../constants/lockerWiseAvailability.constants';
import {
    FetchLockerWiseAvailabilityAndAppointmentsAction,
    LockerWiseAvailabilityAndAppointmentsState,
} from '../interfaces/lockerWiseAvailability.interface';

const initialState: LockerWiseAvailabilityAndAppointmentsState = {
    loading: false,
    data: [],
    errorMsg: '',
    lockerCounts: 0,
    vendorAppointments: []
};

export const lockerWiseAvailabilityAndAppointmentsReducer = (
    state = initialState,
    action: FetchLockerWiseAvailabilityAndAppointmentsAction,
) => {
    switch (action.type) {
        case FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };
        case FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE:
            return {
                loading: false,
                errorMsg: action.payload,
            };
        case GET_LOCKERS_COUNT:
            return {
                ...state,
                lockerCounts: action.payload,
            };
        case FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorAppointments: action.payload,
            };
        default:
            return state;
    }
};
